import { SerializedData } from 'bernie-core';
import { Store } from 'bernie-plugin-mobx';
import { observable } from 'mobx';

import { FlightsShoppingPwaFlightInformationResults } from '__generated__/api';

export class FlightsInfoPriceMatchPromiseStore extends Store {
  @observable public priceMatchPromise: FlightsShoppingPwaFlightInformationResults.FlightsInformationPriceMatchPromise;
  @observable public displayPmp: boolean;
  public hydrate(data: SerializedData): void {
    if (data) {
      Object.assign(this, data);
      this.displayPmp = true;
    }
  }
}

FlightsInfoPriceMatchPromiseStore.DEFAULTS = {};
